import { StorageSection } from "./StorageSection";
// eslint-disable-next-line import/no-default-export
export default StorageSection;
